import React, { Component } from 'react';
import HMax1 from '../Static/hMax/hmax_3.jpg';
import HMax2 from '../Static/hMax/hmax_15.jpg';
import ChangeLocale from "../Components/changeLocale";
import GoBack from "../Components/goBack";
import {FormattedMessage, FormattedHTMLMessage} from "react-intl";

class HMaxTruck extends Component {
	render() {
		const { locale, changeLocale } = this.props;

		return (
			<>
				<GoBack />
				<ChangeLocale locale={locale} changeLocale={changeLocale} />
				<h2>H - MAX</h2>
				<div className='row justifyContent--center'>
					<div className='gallery-picture-wrap'>
						<img decoding="async" className='gallery-picture' src={HMax1} alt='h-max-truck' />
					</div>
					<div className='gallery-picture-wrap'>
						<img decoding="async" className='gallery-picture' src={HMax2} alt='h-max-truck' />
					</div>
				</div>

				<p><FormattedMessage id='hMaxIntro' /></p>
				<p><FormattedMessage id='hMaxContent' /></p>
				<p className='text-align--left'><FormattedHTMLMessage id='hMaxAccessories' /></p>

				{/*<p>Predstavujeme najnovší prírastok do nášho už osvedčeného sortimentu Muck-truck. </p>*/}
				{/*<p>H-MAX prináša o 25% väčšiu kapacitu , odvezie až 450kgs aj v 30 ° svahu a plne naložený. Stroje sú vybavené motormi Honda GXV Commercial triedy 5.5hp, ktoré ponúkajú výkonný systém pohonu všetkých štyroch kolies, čím zabezpečuje maximálnu trakciu pri pohybe nákladu na mokrom, sypkom alebo nerovnom teréne. K dispozícii je celý rad voliteľného príslušenstva.</p>*/}
				{/*<p>Hnacia náprava Tecumseh má 3 rýchlosti vpred a spiatočku. Je vybavený plynovou pákou, ktorá umožňuje presné riadenie rýchlosti jazdy.</p>*/}
				{/*<p>H-Max je typická špeciálna hydraulická sklápacia technológia, ktorá uľahčuje vyklápanie, zatlačením hydraulickej páky dopredu.</p>*/}
				{/*<p>H-Max je postavený s extra výstuhou, ktorá robí stroj robustnejším / silnejším pre extra zaťaženie.</p>*/}
				{/*<p>Vyvážené rozloženie hmotnosti a dlhšie rukoväte umožňuje, že  riadenie je rovnako jednoduché ako u ostatných strojov  radu Muck-truck.</p>*/}
				{/*<p>Všetky sú jednoduché na udržiavanie a bezpečné na používanie.</p>*/}
			</>
		);
	}
}

export default HMaxTruck;
